import { AppProviders } from "@/app/AppProviders";
import { AppRoutes } from "@/app/AppRoutes";
import { GlobalStyle } from "@/shared/theme/GlobalStyle";
import { AppTooltipGlobalStyle } from "@/shared/components/Tooltip/AppTooltip";
import { installGlobalErrorListeners } from "@/shared/lib/userLog";

installGlobalErrorListeners();

function App() {
	return (
		<>
			<GlobalStyle />
			<AppTooltipGlobalStyle />
			<AppProviders>
				<AppRoutes />
			</AppProviders>
		</>
	);
}

export default App;
